import { useEffect } from "react";
import ErrorPage from "../components/UI/ErrorPage";
function NotFound(){
    return (
        <>
        {/* <div className="err_default err_fullPage">
              <p>
                <b>Error:</b>
                <i>
                  {" "}
                  Page Not Found <span className={"errorCode"}>(404)</span>
                </i>
              </p>
            </div> */}
            <div className="err_NotFoundPage">
                <ErrorPage errorCode={404}/>
            </div>
        </>
    )

}
export default NotFound;